import { render, staticRenderFns } from "./homeSchoolThree.vue?vue&type=template&id=3e61cd90&scoped=true"
import script from "./homeSchoolThree.vue?vue&type=script&lang=js"
export * from "./homeSchoolThree.vue?vue&type=script&lang=js"
import style0 from "./homeSchoolThree.vue?vue&type=style&index=0&id=3e61cd90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e61cd90",
  null
  
)

export default component.exports